import React, { useEffect, useLayoutEffect } from 'react'
import { trpc } from '@/trpcReact'
import { Redirect, useLocalSearchParams } from 'expo-router'
import { useClientSession } from '@/hooks/useClientSession.ts'
import { createSupabaseBrowserClient } from '@/client/supabase.ts'
import { useMutation } from '@tanstack/react-query'
import * as Sentry from '@sentry/react-native'

type SignInWithOtpOptions = {
  emailRedirectTo?: string
  shouldCreateUser?: boolean
}

const useSignInWithOtp = () => {
  const supabaseClient = createSupabaseBrowserClient()

  return useMutation({
    mutationFn: async ({ email, options }: { email: string; options?: SignInWithOtpOptions }) => {
      const { error } = await supabaseClient.auth.signInWithOtp({
        email,
        options: {
          shouldCreateUser: true,
          emailRedirectTo: options?.emailRedirectTo || `${window.location.origin}/auth/confirm`,
        },
      })

      if (error) {
        Sentry.captureException(error)
        return { success: false }
      }

      return { success: true }
    },
    retry: false,
  })
}

// http://127.0.0.1:8081/auth/return-to-merchant?checkout_id=ch_7TzLsTjrluKOJJZBgNDuo5&order_id=ord_14s3zwGrPaMWHdGysBVAux&customer_id=cust_2Fdgyh37Nn8Z6ozvLPGSRj&subscription_id=sub_4lpPqJbdLDbzEzlTjIe2yY&product_id=prod_6nPLgdIW99rvc3g5ZKSGiA&signature=b9a6f39369f95a49fec854d0b351f2e363e644092a7ea2580ca27e3fb3140d47
// https://universal-sign-in.com/auth/return-to-merchant?checkout_id=ch_xzh30aR4mN7uvEtiSrGRe&order_id=ord_3woRoWxeMhwk4KngtxqeNJ&customer_id=cust_2tMhua9TAVi5MEY1wC5J3O&subscription_id=sub_5E6xy88akcwRuxddBDKYtM&product_id=prod_6Dsio8im9bvndQOYlI14o2&signature=e4385d0640a1f03a698e9523d0c4ada71e179b3aecb7cc2bca81cf758cd123d7
export default function ReturnToMerchant() {
  const { data: session } = useClientSession()
  const localQueryParams = useLocalSearchParams()

  const { data: userEmailData, isLoading } = trpc.getSubscriptionEmail.useQuery(localQueryParams, {
    enabled: Object.keys(localQueryParams).length > 0,
    retry: false,
    refetchOnWindowFocus: false,
  })

  const { data, mutate, isPending } = useSignInWithOtp()

  const userEmail = userEmailData?.email

  // useEffect(() => {
  //   if (userEmail) {
  //     mutate({ email: userEmail })
  //   }
  // }, [userEmail])

  if (session?.user) {
    return <Redirect href="/configure-sub" />
  }
  if (isLoading || isPending) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 border-8 border-t-transparent border-primary rounded-full animate-spin"></div>
          <p className="text-muted-foreground text-lg">Processing...</p>
        </div>
      </div>
    )
  }

  const url = new URL(`${window.location.origin}/auth/login`)
  if (data?.success) {
    url.searchParams.set('email-sent', 'true')
  }
  if (userEmail) {
    url.searchParams.set('email', userEmail)
  }

  return <Redirect href={url.toString() as any} />
}
